module.exports = __webpack_public_path__ + "static/media/download-w64.984d622d.svg";